/** Colours of La Chiva and La Bolsa (GDD §4.1), pending the world palettes of #20 and #68. Game art, not interface. */
export const LIVERY = {
  yellow: 0xf2c230,
  red: 0xc8322b,
  blue: 0x2459a8,
  tape: 0xb8b0a0,
  bag: 0x9c7a4c,
  propeller: 0x2b2b2b,
  rope: 0x6b5a3a,
} as const;
